import { createEffect, createStore } from "effector"
import { API } from "../API"
import { ILeader } from "../types/leaders"

export const getLeaders = createEffect(async(period:'week' | 'all')=>{
    const res = await API.getLeaders(period);
    
    return res.leaders;
})

export const getUserRaiting = createEffect(async()=>{
    const res = await API.user.getRaiting();

    return res.user_raiting;
})

export const $leaders = createStore<ILeader[]>([])
.on(getLeaders.doneData,(state,res) => res)